import * as React from 'react';
import './index.css';
import Datafeed from './api/'


function getLanguageFromURL() {
	const regex = new RegExp('[\\?&]lang=([^&#]*)');
	const results = regex.exec(window.location.search);
	return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export class TVChartContainer extends React.PureComponent {

	static defaultProps = {
		symbol: 'EURUSD',
		interval: '240',
		containerId: 'tv_chart_container',
		libraryPath: '/charting_library/',
		clientId: 'tradingview.com',
		userId: 'public_user_id',
		fullscreen: true,
		autosize: true,
		studiesOverrides: {},
	};

	componentDidMount() {
		const widgetOptions = {
			debug: false,
			symbol: this.props.symbol,
			datafeed: Datafeed,
			interval: this.props.interval,
			container_id: this.props.containerId,
			library_path: this.props.libraryPath,
			locale: getLanguageFromURL() || 'en',
			disabled_features: ['use_localstorage_for_settings'],
			enabled_features: ['study_templates'],
			charts_storage_url: this.props.chartsStorageUrl,
			charts_storage_api_version: this.props.chartsStorageApiVersion,
			client_id: this.props.clientId,
			user_id: this.props.userId,
			fullscreen: this.props.fullscreen,
			autosize: this.props.autosize,
			studies_overrides: this.props.studiesOverrides,
		};
		console.log('update chart1');
		window.onload = ()=>{
			console.log('onload called');
		}

		setTimeout(()=>{
			console.log('3s after call');
		},3000)
		window.addEventListener(
			'load', 
			() => {
				const widget = window.tvWidget = new window.TradingView.widget(widgetOptions);
				console.log('Event update',widget);
				widget.onChartReady(() => {
					console.log('Chart has loaded!')
				});
			}, 
			false
		)
	}
	render() {
		return (
			<div
				id={ this.props.containerId }
				className={ 'TVChartContainer' }
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/TVChartContainer/index.jsx